import React, { useState, useEffect, useRef } from "react";
import { Button, FormGroup, Row, Col, Label, Form, Modal, ModalHeader, ModalBody, ModalFooter, FormFeedback, Input } from 'reactstrap';
import { Trans } from "react-i18next";


const NoteModal = (props) => {
    const { modal, toggle, submitHandler, data, size, fullscreen, className, centered, scrollable, } = props

    const [validationErrors, setValidationErrors] = useState({});
    const [formData, setFormData] = useState({
      note_content: data?.note_content || '',
    })

    const onSubmit = () => { 
      if (!validateForm()) {
          return;
      }

      submitHandler(formData)

    }

    useEffect(() => { 
      if (data) {
        setFormData(data)
      }

    }, [modal]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value
        });

        setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    };

    const validateForm = () => {
        const errors = {};

        if (!formData.note_content.trim()) {
            errors.note_content = 'Note is required';
        }

        setValidationErrors(errors);
        console.log(errors);
        return Object.keys(errors).length === 0;
    };

    return (
        <Modal 
            isOpen={modal} 
            toggle={toggle} 
            size={size || 'md'} 
            centered={centered}
            scrollable={scrollable}
            className={fullscreen ? `${className} modal-fullscreen` : className} 
        >
            <ModalHeader toggle={toggle}><Trans>Add Note</Trans></ModalHeader>

            <ModalBody style={{ overflowY: 'visible' }}>
              <div className="row">
                <Col md={12}>
                  <Form className="invoice-layout-settings-form">
                    <FormGroup>
                      <Label htmlFor="note_content"><Trans>Note</Trans></Label>
                      <Input
                        defaultValue={formData.note_content}
                        type="textarea"
                        name="note_content"
                        className="form-control"
                        onChange={handleChange}
                        rows={4}
                      />
                      <FormFeedback>{validationErrors.note_content}</FormFeedback>
                    </FormGroup>
                  </Form>
                </Col>
              </div>
                
            </ModalBody>
            <ModalFooter>
              <Button color="danger" onClick={toggle}><Trans>Close</Trans></Button>
              <Button color="primary" onClick={onSubmit}><Trans>Save</Trans></Button>
            </ModalFooter>
        </Modal>
    )
}

export default NoteModal

